<template>
  <div class="desensitize">
    <div>{{ showClearText ? textCleared : text }}</div>
    <div
      v-if="clearText"
      :loading="loading"
      @click="changeMode"
      style="cursor: pointer"
    >
      <svg-icon v-if="showClearText" icon-class="eyefill" />
      <svg-icon v-else icon-class="eyeclosefill" />
    </div>
  </div>
</template>
<script>
import { getClearText } from "@/api/clearText";
export default {
  name: "Desensitize",
  components: {},
  mixins: [],
  props: {
    dataType: {
      type: Number,
      default: 1, // 1.手机2.身份证3微信
    },
    userId: {
      type: Number,
      default: 0,
    },
    clueId: {
      type: Number,
      default: 0,
    },
    clearText: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: "",
    },
    userType: {
      type: Number,
      default: 1, // 1是查客户，2是查经销商成员
    },
  },
  data() {
    return {
      showClearText: false,
      loading: false,
      textCleared: "",
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    changeMode() {
      if (this.showClearText) {
        this.showClearText = false;
      } else {
        this.loading = true;
        getClearText({
          dataType: this.dataType,
          userId: this.userId || undefined,
          clueId: this.clueId || undefined,
          userType: this.userType,
        })
          .then((res) => {
            this.textCleared = res?.data?.data;
            this.showClearText = true;
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
  },
};
</script>
<style scoped>
.desensitize {
  display: flex;
  align-items: center;
}
</style>
